
import { atom } from "recoil";

export const APIBase = atom({
    key: "APIBase",
      // default: "http://localhost:7000",
    //   default: "https://lazy-gray-gorilla-suit.cyclic.app",
    default: "https://backenddeploy.usamafaheemahmed.com",
});